export default "__VITE_ASSET__B987bsq8__"